import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';


export default class extends Controller {
  static targets = ["calendar"]
  static values = {
    locale: { type: String, default: 'zh-TW' },
    events: { type: Array, default: [] },
    initialDate: { type: String, default: '' }
  }

  connect() {
    const target = this.calendarTarget
    const events = this.eventsValue
    const locale = this.localeValue

    const calendar = new Calendar(this.calendarTarget, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      selectable: true,
      fixedWeekCount: false,
      initialDate: this.initialDateValue,
      height: window.innerWidth >= 768 ? window.innerWidth * 0.3486 : window.innerWidth * 0.78,
      dayMaxEvents: window.innerWidth >= 768 ? 3 : 2,
      events: events,
      headerToolbar: {
        start: 'title',
        center: '',
        end: 'prev,next'
      },
      dayHeaderContent: function(arg) {
        return arg.text.toUpperCase(); // 強制大寫
      },
      
      titleFormat: function (date) {
        if (locale === 'zh-TW') {
          return `${date.date.year}年 | ${date.date.month + 1}月`;
        }
        const new_date = new Date(date.date.year, date.date.month, 1);
        const month = new_date.toLocaleString('default', { month: 'long' });
        return `${date.date.year} | ${month}`;
      },

      moreLinkClick: (info) => this.handleMoreLinkClick(info),
      dateClick: (info) => this.handleDateClick(info),
      eventClick: (info) => this.handleEventClick(info)
    });

    calendar.render();
  }

  handleEventClick(info) {
    const dayElement = info.el.closest('.fc-daygrid-day');

    if (!dayElement) {
      console.error('無法找到日期元素');
      return;
    }

    const date = new Date(dayElement.dataset.date);
    this.createCustomPopup(date, dayElement)
  }

  handleDateClick(info) {
    this.createCustomPopup(info.date, info.dayEl)
  }

  handleMoreLinkClick(info) {
    info.jsEvent.preventDefault();
    const moreLinkElement = info.jsEvent.target;
    const dayElement = moreLinkElement.closest('.fc-daygrid-day');

    if (!dayElement) {
      console.error('無法找到日期元素');
      return;
    }

    this.createCustomPopup(info.date, dayElement)
  }

  createCustomPopup(date, dateEl) {
    const popup = document.createElement('div');
    popup.classList.add('custom-fc-popup');
    const extraTop = window.innerWidth >= 768 ? window.innerWidth * 0.055 : window.innerWidth * 0.125
    const extraLeft = window.innerWidth >= 768 ? window.innerWidth * 0.025 : window.innerWidth * 0.075
    popup.style.top = `${dateEl.getBoundingClientRect().top + window.scrollY + extraTop}px`;
    popup.style.left = `${dateEl.getBoundingClientRect().left - extraLeft}px`;

    popup.append(this.getPopupTitleNode(date))

    const events = this.eventsValue.filter((event) => event.start == this.getStartByFormattedDate(date) )
    popup.appendChild(this.getEventsListNode(events));

    document.body.appendChild(popup);
  
    setTimeout(() => {
      document.addEventListener('click', function closePopup(event) {
        if (!popup.contains(event.target)) {
          popup.remove();
          document.removeEventListener('click', closePopup);
        }
      });
    }, 200);
  }

  getPopupTitleNode(dateTime){
    const node = document.createElement('div');
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth()+1
    const date = dateTime.getDate()
    const day = this.getDayName(dateTime.getDay())
    node.textContent = `${year}/${String(month).padStart(2, '0')}/${String(date).padStart(2, '0')}(${day})`
    node.classList.add('title')
    return node
  }

  getStartByFormattedDate(dateTime) {
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth() + 1
    const date = dateTime.getDate()
    return `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`
  }

  getDayName(index) {
    const days = this.localeValue === 'zh-TW'
    ? ['日', '一', '二', '三', '四', '五', '六']
    : ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    return days[index]
  }

  getEventsListNode(events) {
    const eventList = document.createElement('ul');
    events.forEach(event => {
      const listItem = document.createElement('li');
      const time = document.createElement('p');
      time.classList.add('time')
      const company = document.createElement('p');
      company.classList.add('company')
      time.textContent = event.title
      company.textContent = event.company
      listItem.append(time)
      listItem.append(company)
      eventList.appendChild(listItem);
    });
    return eventList
  }
}